import React, { Component } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table'
import Button from 'react-bootstrap/Button';
import authService from '../api-authorization/AuthorizeService'
import LinkButton from '../LinkButton';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../GlobalContext';

export class LocationEnquiry extends Component {
    static displayName = LocationEnquiry.name;

    constructor(props) {
        super(props);
        this.state = { loading: false, inputLocationBarcode: "", alertMessage: "", locationDetails: [] };
        this.history = props.history;
    }

    componentDidMount() {
    }
    goto(page) {
        this.history.push(page);
    }

    render() {
        let loadingProgress = this.state.loading ? <p><em>Loading...</em></p> : <p></p>;

        const handlebarcodeKeyPress = e => {
            if (e.keyCode === 13 || e.charCode === 13 || e.which === 13) {
                this.loadLocationDetails();
            }
        };

        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";

        return <div className="container" >
            <h3>Location Enquiry</h3>
            <Container>
                <Row>
                    <Col> {alertMessage}</Col>
                </Row>
            </Container>
            <Container>
                <Row>
                    <Col>
                        <label>Enter Location Barcode:</label>
                        <input ref="barcodeScanInput" className="form-control" placeholder="Enter Location Barcode"
                            value={this.state.inputLocationBarcode}
                            onChange={(e) => {
                                this.setState({ inputLocationBarcode: e.target.value });
                            }} onKeyPress={handlebarcodeKeyPress} readOnly={this.state.loading}>
                        </input>
                    </Col>
                </Row>
                <Row>
                    <Col >
                        <button type="button" className="btn btn-success col-12 mb-2 mt-1" onClick={() => { this.loadLocationDetails() }}>Search</button>
                    </Col>
                </Row>
                <Row>
                    <Col>{loadingProgress}</Col>
                </Row>
            </Container>
            {this.state.locationDetails.length > 0 && <div className="container">
                <div>
                    <span><b>Status     :</b> {this.state.locationDetails[0].loc_Status}</span><br />
                    <span><b>Charge Type:</b> {this.state.locationDetails[0].loc_Charge}</span><br /><br />
                </div>
                <Table responsive>
                    <thead>
                        <tr>
                            <th>Code</th>
                            <th>Description</th>
                            <th>Grade1</th>
                            <th>Grade2</th>
                            <th>Grade3</th>
                            <th>PackingDate</th>
                            <th>ExpiryDate</th>
                            <th>Qty</th>
                            <th>Client</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.locationDetails.map((row, index) => (
                            <tr key={index}>
                                <td>{row.code}</td>
                                <td>{row.description}</td>
                                <td>{row.grade1}</td>
                                <td>{row.grade2}</td>
                                <td>{row.grade3}</td>
                                <td>{row.packingDate ? new Date(row.packingDate).toLocaleDateString() : ''}</td>
                                <td>{row.expiryDate ? new Date(row.expiryDate).toLocaleDateString() : ''}</td>
                                <td>{row.soh}</td>
                                <td>{row.namecode}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>

            }
        </div>
    }

    async loadLocationDetails() {
        this.setState({ locationDetails: [] });
        this.setState({ loading: true });
        var warehouseID = MyGlobal.warehouse;
        fetch(`api/Enquiry/GetLocationDetails?warehouseId=${warehouseID}&locationBarcode=${this.state.inputLocationBarcode}`)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const data = isJson ? await response.json() : null;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    this.setState({ alertMessage: "Cannot load Location Details. " + errorText, loading: false });
                }
                else {
                    ;
                    this.setState({ locationDetails: data, loading: false, alertMessage: "" });
                }
            })
            .catch(error => {
                this.setState({ alertMessage: error, loading: false });
            });
    }

}

export default LocationEnquiry;